import { createRedline } from "redline-client-sdk";
import type { Redline } from "redline-client-sdk";
import getRedlineAppName from "../../utils/getRedlineAppName";
import { config } from "../brandConfig";

let instance: Redline;
let appName: string;

const RedlineService = {
	start() {
		appName = getRedlineAppName();
		instance = createRedline({
			writeKey: config.redlineKey,
			mode: import.meta.env.VITE_ENV,
			logs: false,
			appName,
			appVersion: import.meta.env.VITE_DEPLOY_VERSION,
		});
	},

	getInstance(): Redline {
		return instance;
	},

	getAppName(): string {
		return appName;
	},
};

export default RedlineService;
